@if (quote.getQuoteType()) {
  <span class="detail">
    <strong class="detail__quote-type">
      {{ getQuoteTypeLabel(quote) }}
    </strong>
  </span>
}

@if (quote.getQuoteType() === quoteType.manual) {
  <span>
    @if (quote.getHtmlContent()?.length > 0) {
      <span
        class="detail"
        [pTooltip]="stripHtmlTags(quote.getHtmlContent())"
        tooltipPosition="top"
      >
        <span>
          {{ stripHtmlTags(quote.getHtmlContent(), 200) }}
        </span>
      </span>
    }
    @if (quote.getHtmlContent()?.length === 0) {
      <span> No content </span>
    }
  </span>
}

@if (quote.getQuoteType() === quoteType.email) {
  <span>
    @if (quote.getEmail()?.getMessage()) {
      <span
        class="detail"
        [pTooltip]="
          stripHtmlTags(
            $safeNavigationMigration(quote.getEmail()?.getMessage())
          )
        "
        tooltipPosition="top"
      >
        <span>
          {{
            stripHtmlTags(
              stripPlaceholders(
                $safeNavigationMigration(quote.getEmail()?.getMessage())
              ),
              200
            )
          }}
        </span>
      </span>
    }
  </span>
}

@if (
  quote.getQuoteType() === quoteType.fcl ||
  quote.getQuoteType() === quoteType.lcl ||
  quote.getQuoteType() === quoteType.air ||
  quote.getQuoteType() === quoteType.multi ||
  quote.getQuoteType() === quoteType.airtariff
) {
  <span>
    @if (quote.getOriginLocations()?.length) {
      <app-location-icon [kind]="quote.getKind()"> </app-location-icon>
    }
    @if (
      quote.getQuoteType() === quoteType.fcl && quote.getEquipment()?.length
    ) {
      <span class="equipment">
        @if (quote.equipment?.length > 0) {
          @for (
            eq of quote.equipment | sortEquipment;
            track eq;
            let last = $last
          ) {
            <span>
              {{ eq | formatContainerLabel }}
              @if (!last) {
                <span>,</span>
              }
            </span>
          }
        }
      </span>
    }
    @if (
      quote.getQuoteType() === quoteType.lcl ||
      quote.getQuoteType() === quoteType.air ||
      quote.getQuoteType() === quoteType.ltl ||
      quote.getQuoteType() === quoteType.ftl ||
      quote.getQuoteType() === quoteType.ptl
    ) {
      <span class="weight-measurement">
        @if (quote.weight) {
          <span>{{ quote.weight }}kg</span>
        }
        @if (quote.weight && quote.measurement) {
          <span>, </span>
        }
        @if (quote.measurement) {
          <span>{{ quote.measurement }}CBM</span>
        }
      </span>
    }
    @if (quote.getOriginLocations()?.length) {
      <span class="detail">
        @for (
          location of quote.getOriginLocations()?.slice(0, 2);
          track location;
          let last = $last;
          let i = $index
        ) {
          <span>
            @if (location.getInlandHaulage()) {
              <span>
                {{ location.getInlandHaulage() }}
                <i class="pi pi-angle-right"></i>
              </span>
            }
            <strong class="location">{{
              location.getLocation()
                ? location.getLocation()?.getName()
                : location.getLocationGroup()?.name
            }}</strong>
            @if (!last) {
              <span>,</span>
            }
          </span>
        }
        @if (quote.getOriginLocations()?.length > 2) {
          <span
            [pTooltip]="getLocationsTooltipHtml(quote.getOriginLocations())"
            [escape]="false"
            tooltipPosition="top"
          >
            (+{{ quote.getOriginLocations()?.length - 2 }})
          </span>
        }
      </span>
    }
    @if (quote.getDestinationLocations()?.length) {
      <i class="pi pi-arrow-right location-separator"></i>
    }
    @if (quote.getDestinationLocations()?.length) {
      <span class="detail">
        @for (
          location of quote.getDestinationLocations()?.slice(0, 2);
          track location;
          let last = $last
        ) {
          <span>
            <strong class="location">{{
              location.getLocation()
                ? location.getLocation()?.getName()
                : location.getLocationGroup()?.name
            }}</strong>
            @if (location.getInlandHaulage()) {
              <span>
                <i class="pi pi-angle-right"></i>
                {{ location.getInlandHaulage() }}</span
              >
            }
            @if (!last) {
              <span>,</span>
            }
          </span>
        }
        @if (quote.getDestinationLocations()?.length > 2) {
          <span
            [pTooltip]="
              getLocationsTooltipHtml(quote.getDestinationLocations())
            "
            [escape]="false"
            tooltipPosition="top"
            >(+{{ quote.getDestinationLocations()?.length - 2 }})</span
          >
        }
      </span>
    }
  </span>
}

@if (
  quote.getQuoteType() === quoteType.ltl ||
  quote.getQuoteType() === quoteType.ftl ||
  quote.getQuoteType() === quoteType.ptl
) {
  <span>
    @if (quote.getOriginLocations()?.length) {
      <app-location-icon [kind]="quote.getKind()"> </app-location-icon>
    }
    @if (quote.getOriginLocations()?.length) {
      <span class="detail">
        @for (
          location of quote.getOriginLocations()?.slice(0, 1);
          track location;
          let last = $last;
          let i = $index
        ) {
          <span>
            {{ location.getPostalCode() }}
            {{ location.getCountry() | countryName }}
          </span>
        }
      </span>
    }
    @if (quote.getDestinationLocations()?.length) {
      <i class="pi pi-arrow-right location-separator"></i>
    }
    @if (quote.getDestinationLocations()?.length) {
      <span class="detail">
        @for (
          location of quote.getDestinationLocations()?.slice(0, 1);
          track location;
          let last = $last;
          let i = $index
        ) {
          <span>
            {{ location.getPostalCode() }}
            {{ location.getCountry() | countryName }}
          </span>
        }
      </span>
    }
    <span class="weight-measurement">
      @if (quote.weight) {
        <span>{{ quote.weight }}kg</span>
      }
      @if (quote.weight && quote.measurement) {
        <span>, </span>
      }
      @if (quote.measurement) {
        <span>{{ quote.measurement }}CBM</span>
      }
    </span>
  </span>
}

@if (quote.getQuoteType() === quoteType.fclTariff) {
  <span>
    @if (quote.getRates()?.length) {
      <span class="detail">
        @for (
          rate of quote.getRates()?.slice(0, visibleDetailItems);
          track rate;
          let last = $last
        ) {
          <span>
            <span>
              {{ rate.getName() }}
            </span>
            @if (!last) {
              <span>,</span>
            }
          </span>
        }
        @if (quote.getRates()?.length > visibleDetailItems) {
          <span
            [pTooltip]="getRatesTooltipHtml(quote.getRates())"
            [escape]="false"
            [appendTo]="QuoteList"
          >
            (+{{ quote.getRates()?.length - visibleDetailItems }})
          </span>
        }
      </span>
    }
  </span>
}
